import type { TAvatar } from "@common";
import { MutableRefObject } from "react";

export const tabsList = [
	"appearance",
	"scene",
	"preview",
] as const;
export type TTabs = typeof tabsList;
export type TTab = TTabs[number];

export interface VoiceLabels {
  accent: string;
  descriptive: string;
  age: string;
  gender: "male" | "female";
  language: string;
  use_case: string;
}

export interface Voice {
  voice_id: string;
  name: string;
  category: "premade" | string;
  labels: VoiceLabels;
  description: string;
  preview_url: string;
}

export interface VoicesResponse {
  voices: Voice[];
}

export interface VoiceTypes {
	voice_id: string;
	name: string;
	gender: string;
	useCase: string;
	ttsEngine: string;
}

export interface VoiceItemTypes {
	value: string;
	description: string;
	onClick: (value: string, ttsEngine: string) => void;
	useCase: string;
	ttsEngine: string;
}

export interface VoiceItemProps extends VoiceItemTypes {
	active: boolean;
	index: number;
}

export interface ModalProps {
	onClose: () => void;
	errorMessage?: string;
	primaryButtonText?: string;
	primaryButtonAction?: () => void;
	subErrorText?: string;
}

interface Thumbnail {
	success: boolean;
	path: string;
	camera: string;
	height: number;
	scene: string;
	width: number;
}

export interface Character {
	_id: string;
	id: string;
	name: string;
	type: "character";
	package: string;
	project: string;
	version: string;
	created: string;
	updated?: string;
	thumbnails: Thumbnail[];
}

export interface Avatar {
	value: string;
	description: string;
	url: string;
	name: string
	type: "2d" | "3d";
}

export interface BrainData {
	brain_id: string;
	llm_id: string;
	prompt_id: string;
}
export interface Scene {
	_id: string;
	id: string;
	name: string;
	type: string;
	package: string;
	project: string;
	version: string;
	created: string;
	thumbnails: string[];
	updated: string;
}

export type Names =  "Алена" | "Таня" | "Ольга" | "Арина" | "Соня" | "Олег" | "Дмитрий" | "Никита" | "Иван" | "Alena" | "Tanya" | "Olga" | "Arina" | "Sonya" | "Oleg" | "Dmitriy" | "Nikita" | "Ivan" | "Лили" | "Lily" | "Kirill" | "Кирилл";

export type Gender = "male" | "female";

export type TGender = "Мужской" | "Женский" | "Female" | "Male";

export type AvatarPrompts = {
	[key in Gender]: (name: Names) => string;
};

export enum LocalStorageKey {
	PlatformAvatars = "platformAvatars",
	PlatformVoices = "platformVoices",
	PlatformScenes = "platformScenes"
}

export interface AvatarsGenderId {
	id: string;
	gender: "male" | "female";
	name: string;
	enName: string;
}

export type AvatarName = "alena" | "tanya" | "sonya" | "arina" | "olga" | "oleg" | "dmitriy" | "nikita" | "ivan" | "lily";

export interface IAvatarGender extends Avatar {
	gender: string;
	avatarRuName: string;
	avatarEnName: string;
	promptKey?: string;
}

export const SUBSCRIPTION_CODES = {
  paid: "x91a",
  free: "u0f3",
};

export type SubscriptionCode = (typeof SUBSCRIPTION_CODES)[keyof typeof SUBSCRIPTION_CODES];
